const currentVendorMaxZIndex = 9999;

export default {
  '.overrideReactSortableHoc': {
    zIndex: currentVendorMaxZIndex,
  },
};
